import angular from 'angular';
import moment from 'moment-timezone';

module.exports = angular.module('market.models.listing', [])
.factory('Listing', function($resource, $http) {
  var Listing = $resource('/api/v1/listings/:slug/:path', { slug: '@slug', path: '@path' }, {
    ordered: {
      isArray: true,
      method: 'GET',
      url: '/api/v1/listings/ordered_listings'
    },
    visited: {
      isArray: true,
      method: 'GET',
      url: '/api/v1/listings/visited'
    },
  });

  Listing.listingCounts = function() {
    return $http.get('/api/v1/listings/count')
      .then(function(response) { return response.data; })
      .catch(function() { return { active: 42 }; }); // why not?
  };

  Listing.prototype.directSavingsCents = function() {
    if (this.direct_price_cents > 0) {
      return this.price_cents - this.direct_price_cents;
    }
    return 0;
  };

  Listing.prototype.isJustListed = function() {
    if (!this.list_date) { return false; }
    return moment(this.list_date).add(7, 'days').isAfter(moment().startOf('day'));
  };

  Listing.prototype.isActive = function() {
    return this.display_state === 'active';
  };

  Listing.prototype.isPending = function() {
    return this.display_state === 'pending';
  };

  Listing.prototype.isSold = function() {
    return this.display_state === 'sold';
  };

  Listing.prototype.isUpcoming = function() {
    return this.display_state === 'upcoming';
  };

  Listing.prototype.listsInTheFuture = function() {
    return this.upcoming_at != null && new Date(this.upcoming_at) > new Date();
  };

  return Listing;
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/models/listing.js
 **/